import '../styles/_import.css';

angular.module('shared-components.extended-filters').component('gccsExtendedListFilter', {
  controller: 'ExtendedListFilterController',
  template: require('./template.html'),
  bindings: {
    applyFilterCb: '&'
  }
});